module.exports = "input.ng-changed {\n  border-color: #78cc37; }\n\ninput.ng-readOnly,\ninput.ng-readOnly:focus {\n  border-color: transparent;\n  background: transparent;\n  outline-color: transparent;\n  outline-style: none;\n  border-color: transparent !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  border-bottom: solid #75787d 1px !important; }\n\ninput.ng-touched.ng-invalid {\n  border-color: #FF586B; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/input-custom/input-custom.component.scss
// module id = ./src/app/component/input-custom/input-custom.component.scss
// module chunks = main